import { call, put, takeLatest } from "redux-saga/effects";
import {
  SET_IN_SESSION_JOINT_VAULT,
  UPDATE_VAULT,
} from "../../../Redux/Actions/actionTypes";
import UpdateVaultRequest from "../../../Communication/ApiClasses/UpdateVaultRequest";
import {
  doLoadingFinish,
  doLoadingStart,
} from "../../Common/ProgressIndicator/Actions/ProgressIndicatorActions";

function* handleSaga(action) {
  yield put(doLoadingStart(`${UPDATE_VAULT}_SAGA`));
  const request = new UpdateVaultRequest(action.data);
  try {
    const result = yield call(request.getData);
    yield put({
      type: `${UPDATE_VAULT}_SUCCESS`,
      data: action.data,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: `${UPDATE_VAULT}_ERROR`,
      error: e.message,
    });
  } finally {
    yield put(doLoadingFinish(`${UPDATE_VAULT}_SAGA`));
  }
}

// watcher
export default function* executeSaga() {
  yield takeLatest(UPDATE_VAULT, handleSaga);
}
